import { render, staticRenderFns } from "./EditArticle.vue?vue&type=template&id=0d7f0253&scoped=true"
import script from "./EditArticle.vue?vue&type=script&lang=js"
export * from "./EditArticle.vue?vue&type=script&lang=js"
import style0 from "./EditArticle.vue?vue&type=style&index=0&id=0d7f0253&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7f0253",
  null
  
)

export default component.exports